import Vue from 'vue'

export const vendorBusinessProfileActions = {
    async 'vendor-business-profile-generate-model'({ dispatch, rootState }, questionnaire) {
        const vendor = await dispatch('user/getVendor', undefined, { root: true })
        const metas = vendor?.metas || {}
        const vendorDetails = JSON.parse(JSON.stringify(rootState.auth.user?.vendor_details || {}))
        if (vendor.id) {
            vendor.service_id = vendorDetails.service_id
            vendor.metas = {
                ...metas,
                brochures: metas.brochures ? (Array.isArray(metas.brochures) ? metas.brochures : JSON.parse(metas.brochures)) : [],
                payment_types: metas.payment_types ? (Array.isArray(metas.payment_types) ? metas.payment_types : JSON.parse(metas.payment_types)) : [],
                additional_services: metas.additional_services
                    ? Array.isArray(metas.additional_services)
                        ? metas.additional_services
                        : JSON.parse(metas.additional_services)
                    : [],
                requirements: metas.requirements ? (Array.isArray(metas.requirements) ? metas.requirements : JSON.parse(metas.requirements)) : [],
            }
        } else {
            vendor.name = vendorDetails.business_name

            if (vendorDetails.email) metas.contact_email = vendorDetails.email
            if (vendorDetails.phone) metas.contact_phone = vendorDetails.phone

            if (vendorDetails.service_id) {
                vendor.service_id = vendorDetails.service_id
                if (parseInt(vendorDetails.service_id) === 3580) metas.is_photographer = true
                const service = rootState.data.taxonomies?.services?.find((service) => service.id === parseInt(vendorDetails.service_id || 0)) || null

                if (service) vendor.taxonomy = [service]
            } else vendor.taxonomy = []

            if (Object.keys(metas).length !== 0) vendor.metas = metas
        }
        dispatch('questionnaire/generateFrontendModel', { model: vendor, questionnaire: questionnaire }, { root: true })
    },
    'vendor-business-profile-done'({ dispatch, rootState }) {
        dispatch('user/update', { ...rootState.auth.user, is_vendor: true }, { root: true })
    },
    async 'vendor-business-profile-save'({ dispatch, rootState }, model) {
        await dispatch('questionnaire/generateModel', {}, { root: true })
        await dispatch('content/submitVendor', { model: rootState.questionnaire.generatedModel }, { root: true })
        await dispatch(
            'user/update',
            {
                ...rootState.auth.user,
                ...{
                    vendor_details: {
                        ...rootState.auth.user.vendor_details,
                        ...{
                            business_name: rootState.questionnaire.generatedModel.name,
                            contact_email: rootState.questionnaire.generatedModel.email,
                            contact_phone: rootState.questionnaire.generatedModel.phone,
                            service_id: rootState.questionnaire.generatedModel.service_id,
                            vendor_id: rootState.questionnaire.generatedModel.id,
                        },
                    },
                },
            },
            { root: true }
        )
    },
}
